import * as Cookies from 'js-cookie';
export default {
  init() {
    // JavaScript to be fired on the about us page
    
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    var place = Cookies.get('loja-id');
    jQuery.ajax({
        method: 'GET',
        url:
          '/wp-json/acf/v3/lojas/'+place,
        success: function (data) {
          // console.log(data);
          var address = data.acf['address'] + '<br>' + data.acf['postal_code'] + '<br>' + data.acf['locality'];
          //console.log(address);
          $('address').html(address);     
        },
      });  
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/checkout.js